import React from "react";
import styled from "styled-components";
import I10n from "../../i10n";
import MsxIcons from "../../msx-icons";
import Button from "../../../atoms/button";
import ReactSelect from "react-select";
import { connect } from "react-redux";
import {
  updateConfigurationRedboxes,
} from "../../configuration-management/ducks";
import { getCompatibleRedboxes } from "./ducks";
import { showNotificationWithButton } from "../../notification/ducks";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  color: #333333;
  max-width: 100%;
  margin: auto;
  border-radius: 10px;

  @media all and (-ms-high-contrast: none) {
    margin: 0px;
    max-height: 100%;
  }

  se-tabbar .opt-content.tab-alternative nav {
    height: auto;
    a {
      flex: 1 1 0px;
    }
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  color: #43ce5d;
  color: var(--se-primary, #43ce5d);
  border-bottom: 2px solid #43ce5d;
  border-bottom: 2px solid var(--se-primary, #43ce5d);
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
  margin-right: 10px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #43ce5d;
  color: var(--se-primary, #43ce5d);
  cursor: pointer;
  ${props => props.$disabled ? 'opacity: 0.5; pointer-events: none;' : ''}
`;

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const DropdownContainer = styled.div`
`;

const SectionTitle = styled.h3`
  margin-bottom: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0px 20px 20px 20px;
`;

class ModalManageRedboxes extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedRedbox: props.configuration.redboxes?.[0],
      candidateRedboxesLoading: false,
      candidateRedboxes: []
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateStateIfMounted({candidateRedboxesLoading: true});
    getCompatibleRedboxes(this.props.configuration).then((candidateRedboxes) => {
      this.updateStateIfMounted({candidateRedboxes});
    })
    .catch(() => {
      this.props.showNotification(I10n.get('modal.manage_redboxes.error.compatible_retrieve'), 'error', () => null);
    })
    .finally(() => {
      this.updateStateIfMounted({candidateRedboxesLoading: false});
    })
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  buildCandidateRedboxes = () => {
    const result = [];
    let actualRedboxMissing = true;

    this.state.candidateRedboxes.forEach((redbox) => {
      if (redbox.id === this.state.selectedRedbox?.id) {
        actualRedboxMissing = false;
      }
      result.push(
        {
          redboxData: redbox,
          value: redbox.id,
          label: I10n.getOrDefault(`modal.manage_redboxes.connectivity.${redbox.connectivity}`, redbox.connectivity),
        }
      );
    });
    if (actualRedboxMissing) {
      result.push(
        {
          redboxData: this.state.selectedRedbox,
          value: this.state.selectedRedbox.id,
          label: I10n.getOrDefault(`modal.manage_redboxes.connectivity.${this.state.selectedRedbox.connectivity}`, this.state.selectedRedbox.connectivity),
        }
      );
    }

    return result;
  }

  handleRedboxChange= (selectedOption) => {
    this.setState({ selectedRedbox: selectedOption.redboxData });
  };

  closeModal () {
    this.props.closeModal();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render = () => {
    const isDisabled = this.state.candidateRedboxesLoading || this.props.configurationSaver.isSaving;

    return (
      <Container>
        <Header>
          <Title>{I10n.get("modal.manage_redboxes.title")}</Title>
          <CloseIcon
            href="#"
            $disabled={isDisabled}
            onClick={(e) => {
              e.preventDefault();
              this.closeModal();
            }}
          >
            <MsxIcons name="modal-close"></MsxIcons>
          </CloseIcon>
        </Header>

        <SelectContainer>
          <DropdownContainer>
            <SectionTitle>{I10n.get("modal.manage_redboxes.connectivity")}</SectionTitle>
            <ReactSelect
              value={{
                redboxData: this.state.selectedRedbox,
                value: this.state.selectedRedbox.id,
                label: I10n.getOrDefault(`modal.manage_redboxes.connectivity.${this.state.selectedRedbox.connectivity}`, this.state.selectedRedbox.connectivity),
              }}
              name="redbox-connectivity"
              options={this.buildCandidateRedboxes()}
              onChange={this.handleRedboxChange}
              isDisabled={isDisabled}
              isSearchable={false}
              menuPlacement="bottom"
            />
          </DropdownContainer>
        </SelectContainer>
        <ButtonContainer>
        <Button
          importance="emphasized"
          disabled={isDisabled}
          onClick={() => {
            this.props.updateConfigurationRedboxes(this.props.configuration, this.state.selectedRedbox.id).then(() => {
              this.props.showNotification(I10n.get('modal.manage_redboxes.success.redbox_update'), 'success', () => null);
              this.closeModal();
            }).catch(() => {
              this.props.showNotification(I10n.get('modal.manage_redboxes.error.redbox_update'), 'error', () => null);
            });
          }}
        >
          {I10n.get('app.action.validate')}
        </Button>

        </ButtonContainer>
      </Container>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    configuration: state.configuration,
    configurationSaver: state.configurationSaver,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfigurationRedboxes: (configuration, redboxId) => dispatch(updateConfigurationRedboxes(configuration, redboxId)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement, 10000)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalManageRedboxes);
